import type * as Types from '../../../../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CurrentUserNameQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CurrentUserNameQuery = { __typename?: 'RootQueryType', currentUser?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null };


export const CurrentUserNameDocument = gql`
    query CurrentUserName {
  currentUser {
    id
    firstName
    lastName
  }
}
    `;

/**
 * __useCurrentUserNameQuery__
 *
 * To run a query within a React component, call `useCurrentUserNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserNameQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserNameQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserNameQuery, CurrentUserNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserNameQuery, CurrentUserNameQueryVariables>(CurrentUserNameDocument, options);
      }
export function useCurrentUserNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserNameQuery, CurrentUserNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserNameQuery, CurrentUserNameQueryVariables>(CurrentUserNameDocument, options);
        }
// @ts-ignore
export function useCurrentUserNameSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CurrentUserNameQuery, CurrentUserNameQueryVariables>): Apollo.UseSuspenseQueryResult<CurrentUserNameQuery, CurrentUserNameQueryVariables>;
export function useCurrentUserNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserNameQuery, CurrentUserNameQueryVariables>): Apollo.UseSuspenseQueryResult<CurrentUserNameQuery | undefined, CurrentUserNameQueryVariables>;
export function useCurrentUserNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserNameQuery, CurrentUserNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserNameQuery, CurrentUserNameQueryVariables>(CurrentUserNameDocument, options);
        }
export type CurrentUserNameQueryHookResult = ReturnType<typeof useCurrentUserNameQuery>;
export type CurrentUserNameLazyQueryHookResult = ReturnType<typeof useCurrentUserNameLazyQuery>;
export type CurrentUserNameSuspenseQueryHookResult = ReturnType<typeof useCurrentUserNameSuspenseQuery>;
export type CurrentUserNameQueryResult = Apollo.QueryResult<CurrentUserNameQuery, CurrentUserNameQueryVariables>;